
import Cookies from "js-cookie";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setIsSignedOut } from "../../../../features/auth/authSlice";
import Gray_Btn from "../../common_btn/gray_btn/Gray_Btn";
import "./Logout_Modal.css";

import { useNavigate } from "react-router-dom";
import { getAllCart } from "../../../../features/cart/cartSlice";
import { getAllWishlist } from "../../../../features/wishlist/wishlistSlice";
import Green_btn from "../../common_btn/green_btn/Green_btn";
import Success_Modal_LogOut from "../success_modal/Success_Modal_logOut";

const Logout_Modal = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showSuccess, setShowSuccess] = useState(false);

  const handleCloseLogout = () => {
    // 1. Close logout confirmation modal first
    props?.onHide();

    // 2. Remove token
    Cookies.remove("gurukrupa_security");

    // 3. Reset auth/cart/wishlist
    dispatch(setIsSignedOut());
    dispatch(getAllCart(false));
    dispatch(getAllWishlist());

    // 4. Show success modal after logout modal closes
    setTimeout(() => {
      setShowSuccess(true);
    }, 300);
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    navigate("/");
  };

  return (
    <>
      {/* LOGOUT CONFIRMATION MODAL */}
      <Modal
        className="Logout_Modal"
        {...props}
        centered
      >
        <Modal.Body>
          <p className="modal_title">Are you sure </p>
          <p className="modal_title">you want to log out?</p>

          <div className="btn_holder">
            <Gray_Btn
              btnText={"No"}
              onClick={() => {
                props?.onHide();
              }}
            />

            <Green_btn
              btnText="Yes"
              onClick={handleCloseLogout}
            />
          </div>
        </Modal.Body>
      </Modal>

      {/* SUCCESS MODAL */}
      <Success_Modal_LogOut
        show={showSuccess}
        onHide={handleSuccessClose}
        successText="LogOut Successful!"
      />
    </>
  );
};

export default Logout_Modal;